import { render, staticRenderFns } from "./NotificationChevronDown.vue?vue&type=template&id=4d8a74dc&scoped=true"
import script from "./NotificationChevronDown.vue?vue&type=script&lang=js"
export * from "./NotificationChevronDown.vue?vue&type=script&lang=js"
import style0 from "./NotificationChevronDown.vue?vue&type=style&index=0&id=4d8a74dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a74dc",
  null
  
)

export default component.exports